import { Reducer } from 'redux';
import { HotTableStoreActions, HotTableStoreState } from '../hotTableStoreTypes';

const activeTableReducer: Reducer<HotTableStoreState['activeTable'], HotTableStoreActions> = (state = null, action) => {
    switch (action.type) {
        case 'SET_ACTIVE_TABLE':
            // Because the action.activeTable is a class instance, its reference is stable.
            // Thus, we need to ensure that a new reference is created when the activeTable is updated
            return action.activeTable ? { instance: action.activeTable } : null;
        default:
            return state;
    }
};

export default activeTableReducer;
